module.exports = __webpack_public_path__ + "img/banner_presentacion.4dfbed04.png";